<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="452px"
    :footer="null"
    :mask-closable="false"
    class="qwdd-close-dialog"
    @cancel="closeHanler"
  >
    <div
      class="dialog-tip-box dialog-tip-blue"
    >
      <i class="icon iconfont iconicon-test68" />
      <h2>{{ $t('message["504"]') }}</h2>
      <div class="d-tip-con">
        <p>
          {{ changeRoleTip[0] }}[{{ rolename }}]{{ changeRoleTip[1] }}。
        </p>
      </div>
      <div class="limit-btn-box">
        <a-button
          type="primary"
          @click="closeHanler"
        >
          {{ $t('message["1276"]') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    rolename: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false
    }
  },
  computed: {
    changeRoleTip () {
      return this.$t('message["687"]').split('|')
    }
  },
  methods: {
    ...mapActions('project', ['closeRoleTip']),
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    },
    async closeHanler () {
      const chain = await this.closeRoleTip()
      chain.onSuccess(raw => {
        this.TipDialogVisible = false
      })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
  .iconicon-test68 {
    color: #4494F0 !important;
  }
  .limit-btn-box {
    margin-top: 30px;
  }
</style>
